import { Directive, forwardRef, HostBinding, Input } from '@angular/core';

import { KH_A11Y_TARGET } from '../constants/a11y-target.token';
import { A11yRole } from '../interfaces/a11y.interfaces';
import { normalizeAriaValue } from '../utils/a11y.util';

import { A11yLabelDirective } from './a11y-label.directive';

@Directive({
  selector: '[khA11yTimer]',
  providers: [{ provide: KH_A11Y_TARGET, useExisting: forwardRef(() => A11yTimerDirective) }]
})
export class A11yTimerDirective extends A11yLabelDirective implements A11yRole {
  @Input('khA11yTimer') public timerLabel: string | null = null;

  @HostBinding('attr.role') public readonly role = 'timer';
  @HostBinding('attr.aria-live') public readonly ariaLive = 'polite';
  @HostBinding('attr.aria-atomic') public readonly ariaAtomic = 'true';

  protected override get ariaLabelValue(): string | null {
    return normalizeAriaValue(this.timerLabel) ?? this.a11yLabel;
  }
}
